import { style } from '@vanilla-extract/css'

export const heading = style({
  fontSize: '20px',
  fontWeight: '700',
  textAlign: 'center',
})

export const productImage = style({
  width: '120px',
  borderRadius: '8px',
})

export const productName = style({
  fontSize: '12px',
  lineHeight: '1.5',
  textAlign: 'center',
})

export const price = style({
  fontSize: '12px',
  fontWeight: '700',
  color: '#F43E3B',
})

export const note = style({
  fontSize: '13px',
  lineHeight: '1.5',
  textAlign: 'center',
})
